/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1SourceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_SOURCE_STATE_ENTITY_NAME = 'ixc.funding.v1.Source';
export const ixcFundingV1SourceStateEntity = new schema.Entity<IxcFundingV1SourceState>(IXC_FUNDING_V1_SOURCE_STATE_ENTITY_NAME, {}, { idAttribute: 'sourceId' });

